<div class="d-flex border-dark-top">
  <div *ngFor="let tab of tabs; let i = index"
    class="p-2 flex-fill d-flex justify-content-center align-items-center disable-select"
    [ngClass]="(tabSelect == tab)?'menu-item-active':'menu-item'" (click)="changeTab(tab)">
    <i class="{{tab?.icon}} mr-1"></i>
    <span>{{tab?.name}}</span>
  </div>
</div>
<app-news-type *ngIf="this.tabSelect?.id == this.perm.news_type_id"></app-news-type>
<app-news *ngIf="this.tabSelect?.id == this.perm.news_id"></app-news>